/* global System */

export default {
  SeparatorSection: () =>
    System.import(/* webpackChunkName: "SeparatorSection" */ './index'),
}
